import { ExhibitionProject } from "interfaces/front/business";
import Head from "next/head";
import React, { FC, useMemo } from "react";
import { OG_SITENAME } from "./constants";
import ResetCss from "../layout/ResetCss";

type Props = {
  project: ExhibitionProject;
  isPreview?: boolean;
};
const ProjectHead: FC<Props> = ({ project, isPreview = false }) => {
  const robotsValue = useMemo(() => (process.env.APP_ENV === "production" && !isPreview ? "all" : "noindex"), []);
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width,initial-scale=1,user-scalable=no" />
        <title key="title">{project.marketing_content.seo_title}</title>
        <meta name="description" content={project.marketing_content.seo_description} />
        <meta name="keywords" content={project.marketing_content.seo_keywords} />
        <link rel="canonical" href={`${process.env.API_CF_BASE_URL}/project/${project.code}`} />
        <meta property="og:title" content={project.marketing_content.og_title} />
        <meta property="og:description" content={project.marketing_content.og_description} />
        <meta property="og:image" content={project.content.main_content_images[0].url} />
        <meta property="og:url" content={`${process.env.API_CF_BASE_URL}/project/${project.code}`} />
        <meta property="og:site_name" content={OG_SITENAME} />
        <meta property="og:locale" content="ja_JP" />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@animefund" />
        <meta property="fb:app_id" content="2809748165906745" />
        <meta name="robots" content={robotsValue} key="robots" />
      </Head>
      <ResetCss />
    </>
  );
};
export default ProjectHead;
